import * as React from 'react';
import styled from 'styled-components';
import { formatCurrency } from 'utils';
import { useBreakpoint } from 'hooks';
import { Text } from '../../Typography';
import Icon from '../../Icon';
import Button from '../../Button';
import Divider from '../../Divider';
import theme from '../../theme';

interface HeaderProps {
  listing?: any;
  fromTourPage?: boolean;
  closeModal: () => void;
}

const Header: React.FC<HeaderProps> = ({
  listing,
  fromTourPage,
  closeModal,
}) => {
  const { md, lg } = useBreakpoint();

  return (
    <>
      <StyledFlex $lg={lg}>
        <StyledFlex $lg={lg}>
          <StyledColumn $titleColumn $md={md} $lg={lg}>
            <StyledTitle>
              {listing.line1 || 'Address'} {listing.line2 || ''}
            </StyledTitle>
            <StyledAddress strong>{`${listing.city || 'City'}, ${
              listing.province || 'Province'
            }, ${listing.postal_code || 'Postal Code'}`}</StyledAddress>
          </StyledColumn>
          <StyledColumn $md={md} $lg={lg}>
            <StyledPriceTag>
              FOR {listing.subtype?.toUpperCase() || 'SALE'}&nbsp;
            </StyledPriceTag>
            <StyledPrice $md={md}>
              {formatCurrency(listing.list_price)}
            </StyledPrice>
          </StyledColumn>
        </StyledFlex>

        {!fromTourPage && (
          <Button
            icon={<Icon type="antdCloseOutlined" />}
            shape="circle"
            type="text"
            onClick={closeModal}
          />
        )}
      </StyledFlex>
      <StyledDivider />
    </>
  );
};

export default Header;

// Refer to listing-title for mobile view CSS
const StyledTitle = styled.span`
  font-size: 36px;
  max-width: calc(100vw - 50px);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  line-height: normal;
  font-weight: 700;
  font-family: Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif;
  color: ${theme.gray8};
`;

const StyledAddress = styled(Text)`
  color: ${theme.gray8};
  margin: 5px 0px;
`;

const StyledPriceTag = styled.div`
  font-weight: 300;
  font-size: 15px;
  line-height: 1.1;
`;

const StyledPrice = styled.div<{ $md: boolean }>`
  font-size: 30px;
  line-height: 1.1;
  font-weight: 700;
  font-family: Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif;
  ${({ $md }) => !$md && `font-size: 15px; margin-left: 2px;`}
`;

const StyledFlex = styled.div<{ $lg: boolean }>`
  display: flex;
  justify-content: space-between;
  flex-basis: 50%;
  ${({ $lg }) => !$lg && `flex-wrap: wrap;`}
`;

const StyledColumn = styled.div<{
  $titleColumn?: boolean;
  $lg?: boolean;
  $md?: boolean;
}>`
  display: flex;
  ${({ $md, $titleColumn }) =>
    ($md || (!$md && $titleColumn)) && 'flex-direction: column;'}
  color: ${theme.gray8};
  ${({ $titleColumn }) => $titleColumn && `min-width: 50%;`}
  ${({ $titleColumn }) =>
    $titleColumn ? `padding-right: 15px;` : `padding: 0px 15px;`}
  ${({ $titleColumn, $lg }) => !$titleColumn && !$lg && `padding: 0 0 2rem 0;`}
`;

const StyledDivider = styled(Divider)`
  margin: 6px 0;
`;
